export enum ViewMode {
    chooseChat = 0,
    chatBot = 1,
    liveChat = 2,
}
